import React from 'react';
import './Legal.css';

function Confidentialite() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Politique de Confidentialité</h1>
        <p>Dernière mise à jour: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. Collecte des Informations</h2>
          <p>Nous collectons les informations suivantes :</p>
          <ul>
            <li>Nom et coordonnées</li>
            <li>Informations de contact (téléphone, email)</li>
            <li>Adresses de prise en charge et de destination</li>
            <li>Données de localisation lors de l'utilisation de nos services</li>
            <li>Préférences de transport</li>
          </ul>
        </section>

        <section>
          <h2>2. Utilisation des Informations</h2>
          <p>Vos informations sont utilisées pour :</p>
          <ul>
            <li>Fournir nos services de transport</li>
            <li>Améliorer notre service client</li>
            <li>Vous contacter concernant votre réservation</li>
            <li>Personnaliser votre expérience</li>
            <li>Assurer la sécurité de nos services</li>
          </ul>
        </section>

        <section>
          <h2>3. Protection des Données</h2>
          <p>Nous mettons en œuvre des mesures de sécurité pour protéger vos informations personnelles, notamment :</p>
          <ul>
            <li>Cryptage des données sensibles</li>
            <li>Accès restreint aux informations personnelles</li>
            <li>Surveillance régulière de nos systèmes</li>
            <li>Formation de notre personnel sur la confidentialité</li>
          </ul>
        </section>

        <section>
          <h2>4. Vos Droits</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès à vos données personnelles</li>
            <li>Droit de rectification</li>
            <li>Droit à l'effacement</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
          </ul>
        </section>

        <section>
          <h2>5. Nous Contacter</h2>
          <p>Pour toute question concernant notre politique de confidentialité, vous pouvez nous contacter :</p>
          <div className="contact-info">
            <p>Email: privacy@taxivd.ch</p>
            <p>Téléphone: +41 XX XXX XX XX</p>
            <p>Adresse: Lausanne, Suisse</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Confidentialite; 